import moment from 'moment';

export const formatDate = (timestamp) => {
  return moment.unix(timestamp).format('MMM DD, YYYY');
};

export const formatTime = (timestamp) => {
  return moment.unix(timestamp).format('hh:mm A');
};

export const formatDateTime = (timestamp) => {
  return moment.unix(timestamp).format('MMM DD, YYYY hh:mm A');
};

export const getRelativeTime = (timestamp) => {
  return moment.unix(timestamp).fromNow();
};

export const isToday = (timestamp) => {
  return moment.unix(timestamp).isSame(moment(), 'day');
};

export const isPast = (timestamp) => {
  return moment.unix(timestamp).isBefore(moment());
};

export const isFuture = (timestamp) => {
  return moment.unix(timestamp).isAfter(moment());
};
